import safeParseUrl from './safeParseUrl';
import truncate from '../text/truncate';

const ELLIPSIS = '[…]';

const truncateUrl = (content: string, maxLength: number, keepLast: number) => {
  const parsedUrl = safeParseUrl(content);
  if (!parsedUrl) {
    return truncate(content, maxLength);
  }

  const { host, pathname, search, hash } = parsedUrl;
  const hostWithoutWww = host.replace(/^www\./, '');
  const lastPart =
    pathname === '/' && search === '' && hash === ''
      ? ''
      : `${pathname}${search}${hash}`;

  const result = `${hostWithoutWww}${lastPart}`;
  if (result.length <= maxLength || lastPart.length === 0) {
    return result;
  }

  const firstPartAllowedExtra = Math.max(
    maxLength - keepLast - ELLIPSIS.length - hostWithoutWww.length,
    0,
  );

  const firstPart = `${hostWithoutWww}${lastPart.slice(
    0,
    firstPartAllowedExtra,
  )}`;

  return `${firstPart}${ELLIPSIS}${lastPart.slice(-keepLast)}`;
};

export default truncateUrl;
